/**
 * A COR DA MARCA DO CANAL — verde do WhatsApp, azul do Messenger…
 *
 * Morava dentro do `InboxName` e o cartão da lista precisou da mesma
 * resposta para o selinho do canal no avatar: duas tabelas iguais seriam
 * duas tabelas para divergir. Canal sem marca conhecida devolve `null` e
 * quem chama usa o cinza do produto.
 */
const CORES_POR_TIPO = {
  'Channel::Whatsapp': '#25D366',
  'Channel::TwilioSms': '#25D366',
  'Channel::FacebookPage': '#0866FF',
  'Channel::Instagram': '#E1306C',
  'Channel::Telegram': '#229ED9',
};

// Caixas de API (a Evolution, por exemplo) escolhem o ícone no cadastro.
const CORES_POR_ICONE = {
  'i-woot-whatsapp': '#25D366',
  'i-woot-messenger': '#0866FF',
  'i-woot-instagram': '#E1306C',
  'i-woot-telegram': '#229ED9',
};

export const corDoCanal = caixa => {
  const icone = caixa?.additional_attributes?.channel_icon;
  if (icone && CORES_POR_ICONE[icone]) return CORES_POR_ICONE[icone];
  return CORES_POR_TIPO[caixa?.channel_type] || null;
};
